module.exports = __webpack_public_path__ + "img/itapevi.860eaa7c.png";